/* 
 * Device Group Profile Collection
 *
 * there is no collection endpoint for listing
 * Device Group Profiles
 * an Account's list can be fetched via the Account Model
 *
 * Profiles are passed as a relationsip of a device group,
 * so we need this colleciton so they are handled like
 * other v5 collections.
 *
 */

import _ from 'underscore';
import Api from '@/lib/api/api';
import Radio from 'backbone.radio';
import v5_Collection from '@/collections/v5/collection';
import DeviceGroupProfile from '@/models/v5/device_group_profile';

var DeviceGroupProfileCollection = new v5_Collection();
_.extend(DeviceGroupProfileCollection, {
    url: function() {
        let user = Radio.request('global', 'active_account');
        return Api.urls.devicegroup_profiles({ id: user.id });
    },
    model: DeviceGroupProfile,
});
export default DeviceGroupProfileCollection;


